import React, { Component } from 'react';


class VideoPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
    this.state = {
      isPlaying: false,
    };
  }

  handlePlay = () => {
    this.videoRef.current.play();
    this.setState({ isPlaying: true });
  };

  handlePause = () => {
    this.setState({ isPlaying: false });
  };

  render() {
    const { src, poster } = this.props;
    return (
      <div className="video_placeholder mb-none" style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <video
          ref={this.videoRef}
          onPlay={() => this.setState({ isPlaying: true })}
          onPause={this.handlePause}
          controls
          src={src}
          type="video/mp4"
          poster={poster}
          style={{maxHeight: 570, maxWidth: this.props.width ? this.props.width : '100%'}}
        />
        {!this.state.isPlaying && (
          <div
            className="video_play hover_dark"
            onClick={this.handlePlay}
          ></div>
        )}
      </div>
    );
  }
}

export default VideoPlayer;
